module.exports = __webpack_public_path__ + "img/maintop.1f11c82.png";